import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MedjunarodnoPrivrednoPravoEJS() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Međunarodno privredno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Međunarodno privredno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Ekonomija javnog sektora
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Međunarodno Privredno Pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Predmet Međunarodno privredno pravo koncipiran je kao
                jednosemestralni kurs koji studentima ekonomije treba da pruži
                osnovna znanja o najznačajnijim pravnim institutima relevantnim
                za oblast međunarodnog poslovnog prometa. Analizom ovih
                instituta sa aspekta domaćeg i uporednog prava prava Evropske
                unije i međunarodnih konvencija sa posebnim osvrtom na njihovu
                praktičnu primenu u poslovnoj praksi kao i odgovarajućih
                slučajeva iz sudske prakse i prakse međunarodnih trgovinskih
                arbitraža zaokružuje se celina pitanja značajnih za poznavanje
                pravnih aspekata međunarodnih poslovnih transakcija. Središte
                izučavanja ovog kursa usmereno je na svojinu i ugovor kao
                osnovne institute pravnog i ekonomskog poretka. Analiza ovih
                instituta praćena je brojnim drugim pitanjima čije poznavanje
                čini neophodan atribut razumevanja operacija međunarodnog
                poslovnog prometa.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon što student položi ispit iz Međunarodnog privrednog prava
                biće u mogućnosti da: Shvati EU i međunarodni pravni okvir u
                kojima se odvijaju poslovne transakcije između poslovnih
                subjekata; Razumije ulogu i značaj i međunarodnih organizacija u
                stvaranju i primjeni poslovnog prava; Razluči ulogu države kao
                subjekta javnog i privatnog- poslovnog prava i shodno tome
                shvati njenu de iure negotii i de iure imperii prirodu;
                Analizira aktuelne procese globalnog poslovnog okruženja kroz
                harmonizaciju i unifikaciju međunarodnog poslovnog prava i
                primjenu model zakona i konvencija; Ovlada osnovama pojedinačnih
                ugovornih odnosa sa elementom inostranosti kao što su: sve vrste
                kupoprodaje zastupanja i druge sa njim povezane poslove; U
                arbitražnoj praksi koristi specijalizovana znanja iz oblasti
                prava stranih ulaganja prava konkurencije i arbitražnog prava te
                pruži konsultantske usluge iz ovih disciplina.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>Prazan tekst u fajlu</p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja se održavaju prema utvrđenom rasporedu uz korišćenje
                savremenih prezentacionih i demonstracionih sredstava i tehnika
                sa primjenom interaktivne metode rada sa studentima čime se
                stiče uvid u njihova predznanja i specifična iskustva zasnovana
                na obrađivanoj problematici ali i uvid u kontiuitet savladavanja
                gradiva. Korišćenje edukativnih sadržaja u elektronskoj i
                digitalnoj formi (koji uključuju i snimljena predavanja i
                mentorske vježbe) na različitim video prezentacionim medijima.
                Vježbe su namjenjene za sticanje praktičnih vještina i
                elaboriranje praktičnih aspekata osnovnih tema. Vježbe sadržajem
                prate tematske jedinice predavanja. Kao specifični oblici vježbi
                primjenjuju se repetitoriji gdje saradnici u nastavi
                (asistentidemonstratori) pripremaju studente za polaganje ispita
                nudeći im koncizni pregled glavnih tačaka određenog predmeta.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>Uvod u pravo</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>Stvarno pravo</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>Stvarno pravo</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>Obligaciono pravo</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>Obligaciono pravo</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>KOLOKVIJUM I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>
                      Načela evropskog ugovornog prava UNIDROIT Načela
                      međunarodnih trgovinskih ugovora Konvencija UN o ugovorima
                      o međunarodnoj prodaji robe
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>Međunarodna prodaja robe</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>Ugovori o trgovinskim uslugama i ugovori o prevozu</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>
                      Ugovori o višim oblicima privredne saradnje; ostali
                      najnačajniji ugovori međunarodnog poslovnog prometa
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>Osnovi kompanijskog prava</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>KOLOKVIJUM II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>Pravni aspekt stranih ulaganja</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>
                      Rješavanje sporova iz međunarodnog poslovnog prometa
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>
                      Rješavanje sporova iz međunarodnog poslovnog prometa
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 3.45h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.15h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MedjunarodnoPrivrednoPravoEJS;
